import React from 'react';
import { 
  BrowserRouter as Router, 
  Routes, 
  Route,
  Navigate
} from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider, ProtectedRoute } from './context/AuthContext';
import MainPage from './pages/MainPage/MainPage';
import ServicosPage from './pages/Servicos/ServicosPage';
import ContatoPage from './pages/FaleConosco/ContatoPage';
import AboutUs from './pages/SobreNos/AboutUs';
// import FAQ from './pages/FAQ/FAQ.js';
import FAQ from './pages/FAQ/FAQ';
import TermosDeUso from './pages/TermosDeUso/TermosDeUso';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade/PoliticaPrivacidade';
import LoginPage from './pages/Login/LoginPage';
import CadastroPage from './pages/Cadastro/CadastroPage';
import PainelPage from './pages/Painel/PainelPage';
import ClientePage from './pages/Cliente/ClientePage';

// Service Pages
import BackofficePage from './pages/Servicos/services/BackofficePage';
import TerceirizacaoPage from './pages/Servicos/services/TerceirizacaoPage';
import ApoioJuridicoPage from './pages/Servicos/services/ApoioJuridicoPage';
import ConsultoriaPage from './pages/Servicos/services/ConsultoriaPage';
import PresencaEstrategicaPage from './pages/Servicos/services/PresencaEstrategicaPage';
import GestaoCadastrosPage from './pages/Servicos/services/GestaoCadastrosPage';
import AlvarasPage from './pages/Servicos/services/AlvarasPage';
import DocumentosPage from './pages/Servicos/services/DocumentosPage';
import RegistroMarcaPage from './pages/Servicos/services/RegistroMarcaPage';

// Wrap the Routes with AuthProvider
function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/nossos-servicos" element={<ServicosPage />} />
      
      {/* Individual Service Pages */}
      <Route path="/servicos/backoffice" element={<BackofficePage />} />
      <Route path="/servicos/terceirizacao" element={<TerceirizacaoPage />} />
      <Route path="/servicos/apoio-juridico" element={<ApoioJuridicoPage />} />
      <Route path="/servicos/consultoria" element={<ConsultoriaPage />} />
      <Route path="/servicos/presenca-estrategica" element={<PresencaEstrategicaPage />} />
      <Route path="/servicos/gestao-cadastros" element={<GestaoCadastrosPage />} />
      <Route path="/servicos/alvaras" element={<AlvarasPage />} />
      <Route path="/servicos/documentos" element={<DocumentosPage />} />
      <Route path="/servicos/registro-marca" element={<RegistroMarcaPage />} />
      
      <Route path="/fale-conosco" element={<ContatoPage />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/termos" element={<TermosDeUso />} />
      <Route path="/privacidade" element={<PoliticaPrivacidade />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/cadastro" element={<CadastroPage />} />
      {/* Protected routes with role-based access */}
      <Route path="/painel/*" element={<ProtectedRoute element={<PainelPage />} allowedRoles={['user']} />} />
      <Route path="/cliente/*" element={<ProtectedRoute element={<ClientePage />} allowedRoles={['cliente']} />} />
      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <ScrollToTop />
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;